export async function fetchRecommendations() {
  const response = await fetch("/recommendations.json");
  return await response.json();
} 